module.exports = __webpack_public_path__ + "static/media/info-icon-svgrepo-com.0eff48bb.svg";